export default "__VITE_ASSET__vnZeFshf__"